export default __webpack_public_path__ + "static/media/hatventure_video.396551e2.gif";